import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import FullScreenLoader from "./FullScreenLoader";

const ShowFoods = () => {
  const { viewFood } = useSelector((state) => state.food);
  const { user } = useSelector((state) => state.loginUser);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(null);
  const BASE_URl = window.location.origin;

  const fetchStoreToggle = useCallback(() => {
    fetch(`${BASE_URl}/api/showStoreToggle`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.store && typeof data.store.isOpen !== "undefined") {
          setIsOpen(data.store.isOpen);
        }
      })
      .catch((error) => {
        toast.error(error.message || "Internal Server Error");
      });
  }, [BASE_URl]);

  useEffect(() => {
    fetchStoreToggle();
    if (!viewFood) {
      navigate("/");
    }
  }, [navigate, viewFood, fetchStoreToggle]);

  if (!viewFood) return null;

  const handleOrderPlaced = async (e) => {
    e.preventDefault();
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, place order!",
    });

    if (result.isConfirmed) {
      if (!user) {
        toast.error("Login First To Place Order");
        navigate("/auth/login");
      } else {
        setLoading(true);
        fetch(`${BASE_URl}/api/order/${user._id}`, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            item: viewFood,
            adress: e.target.adress.value,
            phone: e.target.phone.value,
            paymentMethod: e.target.paymentMethod.value,
          }),
        })
          .then((res) => res.json())
          .then((data) => {
            setLoading(false);
            if (data && data.sucess === true) {
              toast.success(data.messege);
              navigate("/vieworders");
            } else if (data && data.sucess === false) {
              toast.error(data.messege);
            }
          })
          .catch((error) => {
            setLoading(false);
            toast.error(error.message || "Something Went Wrong");
          });
      }
    }
    e.target.reset();
  };

  return (
    <>
      <div className="container mx-auto p-6 mt-14 text-center">
        {loading && <FullScreenLoader />}

        {/* Product Details Section */}
        {viewFood.category && (
          <div className="mb-8 text-center">
            <h2 className="text-3xl font-bold mb-4">{viewFood.category}</h2>
            <img
              src={viewFood.image?.secure_url}
              alt={viewFood.category}
              className="w-full max-w-md mx-auto rounded-lg shadow-lg"
            />
            <pre className="text-gray-600 mt-12 text-justify font-serif whitespace-pre-wrap break-words">
              {viewFood.description}
            </pre>
          </div>
        )}

        {/* Food Item */}
        <div className="flex justify-center mt-5">
          <div className="bg-white shadow-lg rounded-2xl p-6 w-full max-w-sm">
            <img
              src={viewFood.image?.secure_url}
              alt={viewFood.title}
              className="w-full h-40 object-contain rounded-lg"
            />
            <h3 className="mt-4 text-lg font-semibold">{viewFood.title}</h3>
            <p className="text-gray-500">RS: {viewFood.price}</p>
          </div>
        </div>

        {isOpen === false ? (
          <div className="bg-red-500 text-white p-6 mt-10 rounded-lg shadow-lg text-xl font-bold">
            Store has been closed today. Please visit later.
          </div>
        ) : (
          <div className="max-w-md mx-auto p-6 mt-20 mb-20 bg-white shadow-lg rounded-lg">
            <h2 className="text-xl font-bold mb-4">Place Order</h2>
            <form className="space-y-4" onSubmit={handleOrderPlaced}>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Address
                </label>
                <input
                  type="text"
                  name="adress"
                  placeholder="Enter your address"
                  className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Phone Number
                </label>
                <input
                  type="tel"
                  name="phone"
                  placeholder="03XXXXXXXXX"
                  pattern="03[0-9]{9}"
                  maxLength="11"
                  minLength="11"
                  inputMode="numeric"
                  className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Payment Method
                </label>
                <select
                  name="paymentMethod"
                  className="mt-1 cursor-pointer block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="Cash On Delivery">Cash on Delivery</option>
                </select>
              </div>
              <button
                type="submit"
                className="w-full bg-blue-500 text-white p-2 rounded-md hover:bg-blue-600 transition"
              >
                Order Now
              </button>
            </form>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default ShowFoods;
